// extracted by mini-css-extract-plugin
export var columnList = "_ci-0";